export const ORGS_FOR_MARKETING = [
  /*
   * {
   *   name: 'Podium',
   *   logo: 'https://cdn.filestackcontent.com/rg5g49MvSNSG9OFqQBMc',
   * },
   */

  {
    name: 'HeyGen',
    logo: 'https://cdn.filestackcontent.com/yHMvS5TcTmeNlPy4Xjul',
  },
  {
    // eslint-disable-next-line @cspell/spellchecker
    name: 'Synthesia',
    logo: 'https://cdn.filestackcontent.com/0k3DGaHIQ9uUolnq1iPl',
  },
  {
    name: 'ButterflyMX',
    logo: 'https://cdn.filestackcontent.com/mvmLvb6PTjKoKDvtTccB',
  },
  {
    name: 'Swiggy',
    logo: 'https://cdn.filestackcontent.com/G96N0puTT4yKPQHcojIVhttps://cdn.filestackcontent.com/G96N0puTT4yKPQHcojIV',
  },
  {
    name: 'ContentStack',
    logo: 'https://cdn.filestackcontent.com/WLgC5pCzRHCfPb6Uyqpw',
  },
];
